import React, { useState } from 'react';
import MovimientoCM from '../controladorModelo/movimientoCM';
import TablaConsultaInventarioVista from '../vista/tablaConsultaInventarioVista';
import { acciones, IEstadoConsultaInventario } from '../reductorConsultaInventario';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import paginacionRemota from '@infotrack/presentacion-componentes/tabla/paginacionRemota';
import { IPaginador, IRespuestaPaginada } from '@infotrack/presentacion-transversales/interfacesComunes';
import IMovimientoCompuesto from 'Infotrack@Modelos/smartStock/movimientos/entidades/movimientoCompuesta';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
const movimientoCM = new MovimientoCM();
const TablaConsultaInventarioCV: React.FunctionComponent = () => {
    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    const [{ estadoFormularioConsulta, filtros }, dispatch] = useProveedor<IEstadoConsultaInventario>();
    const [cantidadRegistros, setCantidadRegistros] = React.useState<number>(0);
    const refTabla = React.createRef<any>();

    React.useEffect(() => {
        if (refTabla.current) cargarMovimientos();
    }, [refTabla.current]);
    
    
    const adaptadorConsulta = async (paginador: IPaginador, parametros: any) => {
        const respuesta = await movimientoCM.consultarMovimientosCompuestoFiltro(
            paginador,
            parametros.filtros,
            parametros.idEmpresa,
            parametros.IdUsuario
        );
        setCantidadRegistros(respuesta.Paginador.TotalRegistros!)
        return respuesta;
    };
    const consultaMovimientos = paginacionRemota(
        adaptadorConsulta,
        { filtros, idEmpresa }, 
        'FechaMovimiento',
       

    );

    

    const consultarMovimientosParaDescarga = async () => {
        const paginador: IPaginador = { 
            Pagina: 0, 
            PropiedadesDeOrdenamiento: [{ NombrePropiedad: "FechaMovimiento", Orden: 1 }], 
            Registros: refTabla.current.state.query.totalCount 
        };
    
        const respuesta: IRespuestaPaginada<IMovimientoCompuesto> = await adaptadorConsulta(paginador, { 
            filtros, 
            idEmpresa
        });
        const consulta: IMovimientoCompuesto[] = respuesta.Entidades;
    
        return consulta.map(x => ({
            "Bodega": x.BodegaDescripcion,
            "División": x.DivisionDescripcion,
            "Producto": x.DescripcionItem,
            "Tipo Movimiento": x.TipoMovimientoDescripcion,
            "Documento": x.CodigoDocumento,
            "Cantidad": x.Cantidad,
            "Cantidad Total": x.CantidadTotal,
            "Serial": x.Serial,
            "Lote": x.Lote,
            "Fecha De Vencimiento": x.FechaVencimiento ? moment(x.FechaVencimiento).format('YYYY-MM-DD HH:mm') : "",
            "Fecha de Movimiento": x.FechaMovimiento ? moment(x.FechaMovimiento).format('YYYY-MM-DD HH:mm') : "",
            "Fecha de Ingreso": x.FechaIngreso ? moment(x.FechaIngreso).format('YYYY-MM-DD HH:mm') : "",
            "Valor": x.Valor,
            "Peso": x.PesoFraccion,
            "Estado": x.Estado == 1 ? "Activo" : "Inactivo",
            "Codigo producto": x.CodigoEmpresa
        }));
    };
    

    const alCerrarDialogo = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO });
        dispatch({ type: acciones.LIMPIAR_FILTROS });
    };

    const cargarMovimientos = () => {
        refTabla.current!.onQueryChange({ page: 0, pageSize: 10, orderDirection: 'desc', orderBy: null });
    };

    return (
        <TablaConsultaInventarioVista
            alCerrarDialogo={alCerrarDialogo}
            consultaMovimientos={consultaMovimientos}
            estadoDialogo={estadoFormularioConsulta}
            refTabla={refTabla}
            consultarMovimientosParaDescarga={consultarMovimientosParaDescarga}
            cantidadTotal={cantidadRegistros}
        />
    );
};

export default TablaConsultaInventarioCV;
